import { render, staticRenderFns } from "./MasterDataProcedure.vue?vue&type=template&id=9f5e6b16&scoped=true"
import script from "./MasterDataProcedure.vue?vue&type=script&lang=js"
export * from "./MasterDataProcedure.vue?vue&type=script&lang=js"
import style0 from "./MasterDataProcedure.vue?vue&type=style&index=0&id=9f5e6b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5e6b16",
  null
  
)

export default component.exports